import _styled from "styled-components";
import { Tag } from "~/features/ui/tag";
type Props = {
  highlights: string[];
};

// Renders the hardware doc's `productHighlights` array as chip tags. Each highlight
// is a free-form string authored on the hardware doc's Product tab (e.g.
// "Hemispherical FOV", "180°", "20 m").
export function ConfiguratorSpecsList({
  highlights
}: Props) {
  if (!highlights?.length) return null;
  return <_StyledDiv $_css={[{
    "marginBottom": "var(--spacing-xl)",
    "marginTop": "var(--spacing-xl)",
    "display": "flex",
    "flexWrap": "wrap",
    "gap": "0.8rem",
    "@media (min-width: 1024px)": {
      "marginTop": "var(--spacing-4xl)"
    }
  }]}>
      {highlights.map((highlight, i) => <Tag key={i} variant="solid-light-grey">
          {highlight}
        </Tag>)}
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "configurator-specs-list___StyledDiv",
  componentId: "sc-xswttb-0"
})(["", ""], p => p.$_css);